﻿export const SNAP_VERSION = 2;

// Most common keyboard commands (mostly unprintable keycodes right now)
export enum keyboard {
    backspace = 8,
    tab = 9,
    enter = 13,
    shift = 16,
    ctrl = 17,
    alt = 18,
    pause = 19,
    capslock = 20,
    escape = 27,
    pageup = 33,
    pagedown = 34,
    end = 35,
    home = 36,
    left = 37,
    up = 38,
    right = 39,
    down = 40,
    insert = 45,
    deleter = 46,
    space = 32,
    comma = 188
}

export enum events {
    loginRequested = "loginRequested",
    loginSuccessful = "loginSuccessful",
    logout = "logout",
    avatarChanged = "avatarChanged",
    permissionDenied = "permissionDenied",
}

export enum extensions {
    image = "jpg,png,gif,bmp",
    video = "mp4,webm,ogg,ogv",
    environments = "env,dds,hdr"
}

export const currencies = {
    USD: "$",
    EUR: "\u20ac",
    GBP: "\u00a3",
    AUD: "$",
    CAD: "$",
    JPY: "\u00a5"
};

export enum eDateUnit {
    seconds = "Seconds",
    minutes = "Minutes",
    hours = "Hours",
    date = "Date",
    month = "Month",
    fullYear = "FullYear"
}

export enum icons {
    error = "",
    childError = "",
    cancel = "",
    save = "",
    add = "", // "",
    minus = "",
    deleter = "",
    paste = "",
    anonymize = "",
    edit = "",
    hamburger = "",
    change = "",
    help = "",
    info = "",
    infoCircle = "",
    success = "",
    folder = "",
    upload = "",
    download = "",
    refresh = "",
    rename = "",
    crumb = "",
    image = "",
    addFolder = "",
    open = "",
    localization = "",
    camera = "",
    user = "",
    users = "",
    quote = "",
    products = "",
    standardProducts = "",
    company = "",
    gear = "",
    gears = "",
    role = "",
    roles = "", // "",
    theme = "",
    queue = "",
    builder = "",
    tag = "",
    tags = "",
    comment = "",
    attachment = "",
    rule = "", // "",
    popout = "",
    popin = "",
    play = "",    
    list = "",
    tile = "",
    search = "",
    earth = "",
    flag = "",
    mail = "",
    all = "",
    clear = "",
    dollar = "",
    template = "",
    templates = "",
    up = "",
    down = "",
    right = "",
    left = "",
    infrastructure = "",
    database = "",
    integrations = "",
    workflowSelector = "",
    tools = "",
    settings = "",
    permission = "",
    workflow = "",
    email = "",
    approve = "",
    reject = "",
    shipping = "",
    logout = "",
    deploy = "",
    globe = "",
    generators = "",
    generator = "",
    resources = "",
    output = "",
    cleanworkspace = "",
    undo = "",
    redo = "",
    bold = "",
    italic = "",
    heading = "",
    link = "",
    img = "",
    capture = "",
    submit = "",
    unsubmit = "",
    discount = "",
    log = "",
    zoomIn = "",
    zoomOut = "",
    visible = "",
    notVisible = "",
    table = "",
    chevronLeft = "",
    chevronRight = "",
    chevronUp = "",
    chevronDown = "",
    fullscreen = "",
    exitFullscreen = "",
    vr = "",
    clone = "",
    hand = "",
    embed = "",
    safeFunction = "",
    function = "",
    globalDefinition = "",
    reference = "",
    more = "",
    plus = "",
    removed = "",
    test = "",
    name = "",
    cloud = "",
    filter = "",
    warning = "",
    hotspot = "",
    threeD = "",
    cube = "",
    column = "",
    report = "",
    lock = "",
    layout = "",
    layoutConfig = "",
    channels = "",
    history = "",
    view = "",
    automationStudio = "",
    rootUser = "",

    complete = "",
    generating = "",
    failed = "",

    cast = "",
    setVar = "",
    getVar = "",

    alignVertical = "",
    alignRight = "",
    alignLeft = "",
    alignTop = "",
    alignBottom = "",
    alignHorizontal = "",
    shrink = "",
    stretch = "",

    centerText = "",
    leftText = "",
    rightText = "",
    justifyText = "",
    leftIndent = "",
    rightIndent = "",

    rotateRight = "",
    rotateLeft = "",

    // configurator types
    actionBar = "",
    configurator = "",
    page = "",
    group = "",
    ruleContainer = "", // folder
    pricingRuleContainer = "",
    action = "",
    builds = "",
    build = "",
    tabControl = "◰", //"", //"",
    tab = "◳", //"", // "",
    gridRow = "▤", //"",
    gridColumn = "▥", // "",
    accordion = "",
    expander = "", //"",
    button = "",
    toolbar = "",
    popup = "",
    overlayPopupControl = "",
    overlayPopup = "",
    dropdownButton = "",
    content = "",
    priceWidget = "",
    pageControl = "", //"",
    viewer = "", //"",
    canvas = "",
    container = "",
    pageNavigator = "",
    pageTabs = "◰",
    nestedElement = "",
    nestedSet = "",

    // controls
    textbox = "",
    numberbox = "#",
    checkbox = "",
    select = "",
    none = "",
    colorPicker = "",
    colorSelect = "",
    slider = "",
    multilineTextbox = "",
    label = "L",
    imageSelect = "",
    imageMultiSelect = "",
    autoComplete = "",
    media = "",
    mediaPicker = "",
    html = "",
    datePicker = "",
    swatchSelect = "",
    multiSelect = "", // "",
    colorMultiSelect = "",
    toggle = "",
    radio = "",
    svgViewer = "",


    // column types
    text = "",
    number = "",
    boolean = "",
    color = "",
    date = "",
    // localized = "",

    manufacture = "",
    material = "",
    operation = "",
    opdetail = "",

    outputFieldDefault = "",
    outputFieldWordList = "",
    outputFieldWordText = "",
    outputFieldWordImage = "",
    outputFieldWordContainer = "",
    outputFieldCadAnnotation = "",
    outputFieldCadDimension = "",
    outputFieldCadDynamicComponent = "",
    outputFieldMate = "",
    outputFieldCustomProperty = "",
    outputFieldCadComponent = "",
    kbmaxNotifications = "",
    send = "",
    diamond = "⟡",
    robot = "🤖",
    speechbubbles = "🗪",
    robotNeutral = "🤖\uFE0E",
}

export enum svgIcons {
    // NOTE: Setting the height and width of SVGs to "1em"" keeps icons scaled with the font size of HTML elements.
    prism = `<svg width="1em" height="1em" viewBox="0 0 295 319" xmlns="http://www.w3.org/2000/svg"><path d="M294.23 112.507c0-32.909-41.803-47.478-62.389-22.27-24.464 28.319-48.885 56.669-73.349 84.988-19.211 22.241-38.423 44.497-57.619 66.752-6.336 7.321-12.657 14.657-18.978 21.993-6.131 7.028-13.212 13.736-12.905 24.023-.146 21.92 27.347 32.836 42.315 17.097 16.636-16.176 33.287-32.353 49.923-48.529 29.029-28.218 58.044-56.45 87.103-84.653 8.691-8.446 17.397-16.892 26.073-25.353 10.403-9.747 19.943-18.164 19.826-34.063v.015Z" fill="url(#a)"/><path d="M31.796 18.21C26.265 13.095 19.608 7.995 11.78 9.296-0.335 11.722-1.989 24.61 4.405 33.772c53.552 69.923 91.682 144.128 63.78 233.515-4.243 12.143-10.871 23.892-4.287 36.708 10.813 21.963 42.885 19.113 50.333-3.946 11.515-46.732 14.002-96.825 1.302-143.747C100.872 106.019 69.238 54.903 31.942 18.327l-.146-.132v.015Z" fill="url(#b)"/><path d="M272.444 79.628c-13.768-6.722-28.312-1.768-42.651-.848-47.056 3.215-93.584-11.003-133.719-35.012-14.046-8.212-27.61-17.521-40.179-27.94C47.277 8.726 37.533.25 25.871 0 4.377-.246-6.421 22.725 4.026 40.392c23.762 38.198 87.278 76.163 129.315 91.55 32.702 12.114 67.496 17.828 102.305 19.099 12.817.395 27.419 1.739 39.008-4.384 26.629-14.364 26.439-54.184-1.961-66.912l-.263-.117h.014Z" fill="url(#c)"/><defs><linearGradient id="a" x1="98.5" y1="328" x2="173.121" y2="126.885" gradientUnits="userSpaceOnUse"><stop stop-color="#FFA337"/><stop offset=".259" stop-color="#F65D5D"/><stop offset=".737" stop-color="#F557FF"/><stop offset="1" stop-color="#DD98FF"/></linearGradient><linearGradient id="b" x1="75.5" y1="319" x2="146.166" y2="59.545" gradientUnits="userSpaceOnUse"><stop stop-color="#FFA337"/><stop offset=".269" stop-color="#FF619E"/><stop offset=".737" stop-color="#F557FF"/><stop offset="1" stop-color="#DD98FF"/></linearGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(241.5 63) rotate(114.191) scale(140.322 314.371)"><stop stop-color="#8CFCF5"/><stop offset=".384" stop-color="#AFD5FF"/><stop offset="1" stop-color="#7B7CFF"/></radialGradient></defs></svg>`,
    prismMonochrome = `<svg width="1em" height="1em" viewBox="0 0 295 319" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M294.23 112.507c0-32.909-41.803-47.478-62.389-22.27-24.464 28.319-48.885 56.669-73.349 84.988-19.211 22.241-38.423 44.497-57.619 66.752-6.336 7.321-12.657 14.657-18.978 21.993-6.131 7.028-13.212 13.736-12.905 24.023-.146 21.92 27.347 32.836 42.315 17.097 16.636-16.176 33.287-32.353 49.923-48.529 29.029-28.218 58.044-56.45 87.103-84.653 8.691-8.446 17.397-16.892 26.073-25.353 10.403-9.747 19.943-18.164 19.826-34.063v.015ZM31.796 18.21C26.265 13.095 19.608 7.995 11.78 9.296-0.335 11.722-1.989 24.61 4.405 33.772c53.552 69.923 91.682 144.128 63.78 233.515-4.243 12.143-10.871 23.892-4.287 36.708 10.813 21.963 42.885 19.113 50.333-3.946 11.515-46.732 14.002-96.825 1.302-143.747C100.872 106.019 69.238 54.903 31.942 18.327l-.146-.132v.015ZM272.444 79.628c-13.768-6.722-28.312-1.768-42.651-.848-47.056 3.215-93.584-11.003-133.719-35.012-14.046-8.212-27.61-17.521-40.179-27.94C47.277 8.726 37.533.25 25.871 0 4.377-.246-6.421 22.725 4.026 40.392c23.762 38.198 87.278 76.163 129.315 91.55 32.702 12.114 67.496 17.828 102.305 19.099 12.817.395 27.419 1.739 39.008-4.384 26.629-14.364 26.439-54.184-1.961-66.912l-.263-.117h.014Z"/></svg>`,
    thumbsUp = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.1818 9.36364H14.4455L15.3091 5.20909L15.3364 4.91818C15.3364 4.54545 15.1818 4.2 14.9364 3.95455L13.9727 3L7.99091 8.99091C7.65455 9.31818 7.45455 9.77273 7.45455 10.2727V19.3636C7.45455 20.3636 8.27273 21.1818 9.27273 21.1818H17.4545C18.2091 21.1818 18.8545 20.7273 19.1273 20.0727L21.8727 13.6636C21.9545 13.4545 22 13.2364 22 13V11.1818C22 10.1818 21.1818 9.36364 20.1818 9.36364Z" fill="currentColor"></path><path d="M5.63636 10.2727H2V21.1818H5.63636V10.2727Z" fill="currentColor"></path></svg>`,
}
